import { getCookie } from '@/utils/utils'
import { companyLangToLocale } from '@/config/localeConfig'

const isCseHtmlLang = (htmlLang: string): boolean =>
	htmlLang === 'fr-FR-CSE' || htmlLang === 'fr_FR_CSE'

/** CSE: companyLang nl → nl, otherwise fr. */
export function getCseCompanyLangCode(): 'nl' | 'fr' {
	const companyLang = getCookie('companyLang')
	if (companyLang?.toLowerCase().trim() === 'nl') {
		return 'nl'
	}
	return 'fr'
}

/** Short language code for picking nl:/fr: segments in review text. */
export function getSiteLangCode(htmlLang: string | null | undefined): string {
	if (!htmlLang) {
		return 'fr'
	}
	if (isCseHtmlLang(htmlLang)) {
		return getCseCompanyLangCode()
	}
	return htmlLang.toLowerCase().replace('_', '-').slice(0, 2)
}

/** BCP 47 locale for Intl date formatting. */
export function getLocaleForReviewDates(htmlLang: string | null | undefined): string {
	if (!htmlLang) {
		return 'fr-FR'
	}
	if (isCseHtmlLang(htmlLang)) {
		return companyLangToLocale.get(getCseCompanyLangCode()) || 'fr-FR'
	}
	const normalized = htmlLang.toLowerCase().replace('_', '-')
	return companyLangToLocale.get(normalized.slice(0, 2)) || htmlLang
}

/** Pick the segment matching site language from `nl: ... | fr: ...` text. */
export function extractLocalizedSegment(
	raw: string | null | undefined,
	htmlLang: string | null | undefined
): string {
	if (!raw || typeof raw !== 'string') {
		return ''
	}

	const parts = raw.split(/\s*\|\s*/)
	const langMap: Record<string, string> = {}

	for (const part of parts) {
		const match = part.match(/^(\w{2}):\s*(.+)$/s)
		if (match) {
			langMap[match[1].toLowerCase()] = match[2].trim()
		}
	}

	if (Object.keys(langMap).length === 0) {
		return raw
	}

	const siteLang = getSiteLangCode(htmlLang)
	return langMap[siteLang] || langMap.fr || Object.values(langMap)[0] || raw
}
